module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', [_vm._v(_vm._s(_vm.$route.params.id))]), _vm._v(" "), _c('form', {
    staticClass: "myform"
  }, [_c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showMe
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('div', {
    staticClass: "router-row"
  }, [_c('router-link', {
    attrs: {
      "to": "/login/bar/profile"
    }
  }, [_vm._v("Login-bar")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0dc1b752!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 146
// module chunks = 0